module.exports = __webpack_public_path__ + "static/media/qr-codes-desktop-top.b1f3fcd7.png";